import React, { useEffect, useState } from 'react';
import './CreateResource.css';
import { MdKeyboardBackspace } from 'react-icons/md';
import { AutoComplete, Button, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import { RxCross2 } from 'react-icons/rx';
import { MdAdd } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../Components/Loader/Loader';

const Workspaces_icon = '/assets/workspace_Icon.svg';
const ImageIcon = '/assets/Image-icon.svg';
const SearchIcon = '/assets/SearchIcon.svg';
const blackLock = '/assets/black-lock.svg';
const boldMember = '/assets/bold-people.svg';
const profile = '/assets/profile.svg';

const CreateNewResource = () => {
    let Navigate = useNavigate();
    let dispatch = useDispatch();
    const [selectedValue, setSelectedValue] = useState('');
    const [resourceName, setResourceName] = useState(null);
    const [accessLevel, setAccessLevel] = useState('');
    const [workspaceId, setWorkspaceId] = useState([]);
    const [addedMembers, setAddedMember] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [duplicateData, setDuplicateData] = useState('');
    const [checkMember, setCheckMember] = useState(false);
    const [resourceDescription, setResourceDescription] = useState('');

    const [teamMember, setTeamMember] = useState([]);

    const teamMemberData = useSelector(
        (state) => state?.workspaces_TeamMember_Data?.workspace_TeamMember_data
    );

    const workspaceCreateLoader = useSelector(
        (state) => state?.workspaces_Create_Data?.loader
    );
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedFile(file);
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();

        const formData = {
            resourceName,
            resourceDescription,
            selectedFile,
        };
    };

    // const options = teamMember?.map((item, index) => ({
    //     key: item?.id,
    //     value: item?.first_name + ' ' + item?.last_name,
    //     label: (
    //         <div
    //             className='member-added-dropdown'
    //             key={item?.id}
    //            >
    //             <div className='member-added-dropdown-data'>
    //                 <img src={profile} alt='' />
    //                 <div>
    //                     <p>
    //                         {item?.first_name} {item?.last_name}
    //                     </p>
    //                     <p>{item?.first_name.toLowerCase()}@gmail.com</p>
    //                 </div>
    //             </div>
    //             <div>
    //                 <MdAdd />
    //                 <p>Add</p>
    //             </div>
    //         </div>
    //     ),
    // }));

    return (
        <div className='new_workspace_main workspace-container'>
            {workspaceCreateLoader && <Loader />}
            <div className='new_workspaces-container'>
                <h3>Create New Resource</h3>
                <div
                    className='new-workspace-back'
                    onClick={() => Navigate('/resources')}>
                    <MdKeyboardBackspace />
                    Back
                </div>
                <div className='new_workspaces_inner'>
                    <h4>Resource</h4>
                </div>
                <div className='workspace-input-container'>
                    <form onSubmit={handleFormSubmit}>
                        <div className='workspaces-input-field'>
                            <label>Resource name</label>
                            <Input
                                placeholder='resource name'
                                value={resourceName || ''}
                                onChange={(e) => {
                                    setResourceName(e.target.value);
                                    setErrorMessage('');
                                }}
                            />
                            {errorMessage && (
                                <div className='error-message'>
                                    {errorMessage}
                                </div>
                            )}
                        </div>

                        <div className='workspace-seprator'></div>

                        <div className='workspaces-input-field'>
                            <label>Resource Description</label>
                            <Input
                                placeholder='resource description'
                                value={resourceDescription || ''}
                                onChange={(e) => {
                                    setResourceDescription(e.target.value);
                                    setErrorMessage('');
                                }}
                            />
                        </div>
                        <div className='added-member_div'>
                            {!addedMembers.length ? (
                                <div className='add-workspaces-email'>
                                    Please enter resource description.
                                </div>
                            ) : (
                                <p>Members</p>
                            )}
                        </div>

                        <div className='workspace-seprator'></div>

                        <div className='file-uploader'>
                            <label htmlFor='fileInput' className='file-label'>
                                Choose a file
                            </label>
                            <input
                                type='file'
                                id='fileInput'
                                onChange={handleFileChange}
                                accept='.mp4, .mov, .avi, .mkv, .webm'
                            />
                            {selectedFile && (
                                <span className='file-name'>
                                    {selectedFile.name}
                                </span>
                            )}
                        </div>

                        <div className='add-workspace-member'>
                            <div className='workspace-seprator'></div>
                            <div className='create-workspace-btn'>
                                <button className='main-api-btn' type='submit'>
                                    Create Resource
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateNewResource;
